import { injectEntityList } from '../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { IEntityListStore } from '../../../../../../common/store/interface/IEntityListStore';
import { IPrimitiveStore } from '../../../../../../common/store/interface/IPrimitiveStore';
import { IProjectLearningReportArg } from '../../../../../../service/report/interface/IProjectLearningReportArg';
import { ILearningUserRatingModel } from '../../../../../../service/report/interface/ILearningUserRatingModel';
import { IUserRatingsDomain } from './IUserRatingsDomain';
import { IUserRatingsUI } from './IUserRatingsUI';

export class UserRatingsUI implements IUserRatingsUI {
  private alreadyBooted: IPrimitiveStore<boolean>;
  isFetching: IPrimitiveStore<boolean>;
  rows: IEntityListStore<ILearningUserRatingModel>;

  constructor(
    private userRatingsDomain: IUserRatingsDomain,
    private reportArg: IProjectLearningReportArg = {},
  ) {
    this.alreadyBooted = injectPrimitive(false);
    this.isFetching = injectPrimitive(false);
    this.rows = injectEntityList<ILearningUserRatingModel>([]);
  }

  boot = async () => {
    if (this.alreadyBooted.value) return;
    this.isFetching.setValue(true);
    try {
      this.rows.setList(await this.userRatingsDomain.getUserRatings(this.reportArg));
    } finally {
      this.alreadyBooted.setValue(true);
      this.isFetching.setValue(false);
    }
  };

  search = async (searchTerm: string) => {
    this.isFetching.setValue(true);
    try {
      this.rows.setList(
        await this.userRatingsDomain.getUserRatings({
          ...this.reportArg,
          search: searchTerm || undefined,
        }),
      );
    } finally {
      this.isFetching.setValue(false);
    }
  };
}
